export default __webpack_public_path__ + "static/media/28d9a3779173e7006acf35f736e456411581601115875.6bc33cf6.webp";